module.exports = __webpack_public_path__ + "static/media/wallpaper4.2fc42840.jpg";